import { Component, EventEmitter, Input, OnInit, Output, ViewChild, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';

import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatStepperModule } from '@angular/material/stepper';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatChipsModule } from '@angular/material/chips';

@Component({
    selector: 'app-motivation-demande-form',
    imports: [
    MatInputModule,
    MatFormFieldModule,
    MatIconModule,
    MatButtonModule,
    MatStepperModule,
    ReactiveFormsModule,
    MatChipsModule
],
    schemas: [CUSTOM_ELEMENTS_SCHEMA],
    templateUrl: './motivation-demande-form.component.html',
    styleUrls: ['./motivation-demande-form.component.scss']
})
export class MotivationDemandeFormComponent implements OnInit {
  // Make Validators available in template
  public ValidatorsRef = Validators;
  @Input() motivationRequestForm!: FormGroup;
  @Output() formSubmit = new EventEmitter<FormGroup>();
  @ViewChild('fileInput') fileInput!: HTMLInputElement;
  @Output() filesSelected = new EventEmitter<File[]>();
  selectedFileNames: File[] = [];
  invalidFile: boolean = false;
  isDragging = false;
  nbreCaratereTexte: string = "Votre texte ne doit pas dépasser 720 caractères."
  constructor(private fb: FormBuilder) { }

  ngOnInit() { }

  onSubmit() {
    if (this.motivationRequestForm.valid) {
      this.formSubmit.emit(this.motivationRequestForm);
    }
  }

  onReset() {
    this.motivationRequestForm.reset();
  }
  triggerFileInput(fileInput: HTMLInputElement) {
    fileInput.click();
  }
  // onFileSelected(event: any) {
  //   // const input = event.target as HTMLInputElement;
  //   if (event.target.files) {
  //     //this.selectedFileNames = Array.from(input.files).map((file) => file.name);
  //     this.selectedFileNames = Array.from(event.target.files);
  //     this.filesSelected.emit(this.selectedFileNames);

  //   }
  // }
  onFileSelected(event: any) {
    if (event.target.files) {
      const files = Array.from(event.target.files) as File[];
      const pdfFiles = files.filter((file) => file.type === 'application/pdf');

      if (pdfFiles.length === files.length) {
        this.invalidFile = false;
        this.selectedFileNames = [...this.selectedFileNames, ...pdfFiles];
        this.motivationRequestForm.get('files')?.setValue(this.selectedFileNames);
        this.filesSelected.emit(this.selectedFileNames);
      } else {
        this.invalidFile = true;
      }
    }
    if (event.target) {
      // Reset input so selecting the same file again triggers a change event.
      event.target.value = '';
    }
  }
  removeFile(index: number) {
    this.selectedFileNames.splice(index, 1);
    this.motivationRequestForm.get('files')?.setValue(this.selectedFileNames);
  }
  onDragOver(event: DragEvent) {
    event.preventDefault();
    event.stopPropagation();
    this.isDragging = true;
  }

  onDragLeave(event: DragEvent) {
    event.preventDefault();
    event.stopPropagation();
    this.isDragging = false;
  }

  // handleDragDrop(event: DragEvent) {
  //   event.preventDefault();
  //   event.stopPropagation();
  //   this.isDragging = false;

  //   if (event.dataTransfer?.files) {
  //     const droppedFiles = Array.from(event.dataTransfer.files);
  //     const pdfFiles = droppedFiles.filter((file) => file.type === 'application/pdf');

  //     if (pdfFiles.length !== droppedFiles.length) {
  //       this.invalidFile = true;
  //       return;
  //     }

  //     this.invalidFile = false;
  //     this.selectedFileNames = [...this.selectedFileNames, ...pdfFiles];
  //     this.filesSelected.emit(this.selectedFileNames);
  //   }
  // }

  handleDragDrop(event: DragEvent) {
    event.preventDefault();
    event.stopPropagation();
    this.isDragging = false;

    if (event.dataTransfer?.files) {
      const droppedFiles = Array.from(event.dataTransfer.files) as File[];
      const pdfFiles = droppedFiles.filter((file) => file.type === 'application/pdf');

      if (pdfFiles.length !== droppedFiles.length) {
        this.invalidFile = true;
        return;
      }

      this.invalidFile = false;
      this.selectedFileNames = [...this.selectedFileNames, ...pdfFiles];
      this.motivationRequestForm.get('files')?.setValue(this.selectedFileNames);
      this.filesSelected.emit(this.selectedFileNames);
    }
  }
}
